export default class Seniority {
  id: string;

  name: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
  }

  public static of(obj: any): Seniority {
    return new Seniority(obj);
  }

  public static ofList(members: any): Seniority[] {
    return members.map((seniority: any) => new Seniority(seniority));
  }
}
